import {CONFIG} from "../util/config";
import {handleJsonResponse} from "./api";
import {QueryField} from "../containers/QueryBuilder/types/Query";
import {QueryMetaData} from "../containers/QueryBuilder/types/QueryMetaData";
import {ChartType} from "../containers/QueryBuilder/visualisations/types/ChartType";

export type ChartOptions = {
    queryId: string
    chartType: ChartType,
    xFields: QueryField[] // fields dragged into the x-axis
    yFields: QueryField[] // fields dragged into the y-axis
    values: QueryField[]
    filters: Record<string, string[]>
    sort: number
    topTen: boolean
}

export type ChartResults = {
    labels: string[]
    values: ChartValues[]
}

export type ChartValues = {
    name: string
    data: Array<Array<number>>
}

export const getUrl = (): string => {
    return `${CONFIG.restPrefix}/query-builder/`
}

export const apiFetchQueryMetaData = async (queryId: string): Promise<QueryMetaData> => {
    const url = getUrl() + `query-metadata/${queryId}`
    const result = await fetch(url, {
        ...(CONFIG.isDev && { credentials: 'include' })
    })
    return handleJsonResponse(result)
}

export const apiFetchChartData = async(chartOptions: ChartOptions): Promise<ChartResults> => {
    const url = getUrl() + `chart-data`
    const result = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            queryId: chartOptions.queryId,
            xfields: chartOptions.xFields,
            yfields: chartOptions.yFields,
            values: chartOptions.values,
            filters: chartOptions.filters
        }),
        ...(CONFIG.isDev && { credentials: 'include' })
    })
    return handleJsonResponse(result)
}

